export const urlHasProtocol = (urlStr: string): boolean => {
  try {
    const url = new URL(urlStr);
    return url.protocol.length > 0;
  } catch {
    return false;
  }
};
